module.exports = __webpack_public_path__ + "img/paper.f2a4aeab.png";